import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://iltuoamaro.it';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://trade-fair-preview.preview.emergentagent.com';

const SEO = ({
  title = "Il Tuo Amaro | Liquori Personalizzati B2B - Migliore Distilleria Italiana 2025",
  description = "Liquorificio Lacinio - Migliore Distilleria Italiana 2025 e produttore del Miglior Amaro al Mondo. Crea liquori personalizzati per la tua attività con ingredienti calabresi di qualità. Ordine minimo 24 bottiglie.",
  keywords = "amaro personalizzato, liquori artigianali, distilleria italiana, amaro calabrese, liquori b2b, produzione liquori, amaro su misura, liquorificio lacinio, migliore distilleria italia",
  image = `${BACKEND_URL}/api/upload/serve/static/images/liquorificio.webp`,
  url = SITE_URL,
  type = "website",
  author = "Liquorificio Lacinio",
  locale = "it_IT",
  structuredData = null
}) => {
  const siteUrl = SITE_URL;
  const canonicalUrl = `${siteUrl}${url}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={locale} />
      <meta property="og:site_name" content="Il Tuo Amaro" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="Italian" />
      <meta name="geo.region" content="IT-KR" />
      <meta name="geo.placename" content="Crotone" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
